import React, { useRef, useState } from 'react';
import emailjs from '@emailjs/browser';

export default function Contact() {
  const form = useRef();
  const [sent, setSent] = useState(false);
  const [error, setError] = useState('');

  // TODO: Replace these with your actual EmailJS credentials
  const USER_ID = 'zIIDQg6P44xeUmlWA';
  const SERVICE_ID = 'service_nl8zh7b';
  const TEMPLATE_ID = 'template_3z4vivv';

  const sendEmail = (e) => {
    e.preventDefault();
    setError('');
    emailjs.sendForm(SERVICE_ID, TEMPLATE_ID, form.current, USER_ID).then(
      (result) => {
        setSent(true);
      },
      (error) => {
        setError('Failed to send. Please try again later.');
      },
    );
  };

  return (
    <section id="contact" className="container contact">
      <h2>Contact</h2>
      <p>
        If you'd like to get in touch, email me at{' '}
        <a href="mailto:galvanadrian1323@gmail.com">
          galvanadrian1323@gmail.com
        </a>
        .
      </p>
      <form ref={form} className="contact-form" onSubmit={sendEmail}>
        <label>
          Name
          <input type="text" name="name" required />
        </label>
        <label>
          Email
          <input type="email" name="email" required />
        </label>
        <label>
          Message
          <textarea name="message" rows="4" required />
        </label>
        <button className="btn" type="submit" disabled={sent}>
          {sent ? 'Sent!' : 'Send'}
        </button>
        {error && <p style={{ color: 'red' }}>{error}</p>}
      </form>
    </section>
  );
}
